module.exports = __webpack_public_path__ + "img/h zwaardecroon containers voor.86020c0b.jpg";